import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00076006"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_order_request_item_sub",
  ref: "orderRequestItemRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_order_request_item_sub_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_order_request_item_sub_scroll",
  "data-kt-scroll": "false",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_order_request_item_sub_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_order_request_item_sub_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6 form-group mb-7" }
const _hoisted_12 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_13 = { class: "col-md-6 form-group mb-7" }
const _hoisted_14 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_15 = { class: "col-md-6 form-group mb-7" }
const _hoisted_16 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_17 = { class: "col-md-6 form-group mb-7" }
const _hoisted_18 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_19 = { class: "col-md-6 form-group mb-7" }
const _hoisted_20 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_21 = { class: "col-md-6 form-group mb-7" }
const _hoisted_22 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_23 = { class: "col-md-6 form-group mb-7" }
const _hoisted_24 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_25 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_26 = { class: "modal-footer flex-center" }
const _hoisted_27 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_28 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_29 = { class: "indicator-label" }
const _hoisted_30 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_31 = { class: "indicator-progress" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.props.itemSubIndex === -1 ? _ctx.t("common.add") : _ctx.t("common.edit")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        (_ctx.props.itemId !== 0)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.formData,
              rules: _ctx.rules,
              ref: "formRef"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("order.merchantOrderNo")), 1),
                        _createVNode(_component_el_form_item, { prop: "merchant_order_number" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.merchant_order_number,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.merchant_order_number) = $event)),
                              type: "text",
                              placeholder: _ctx.t('common.plsEnter'),
                              clearable: "",
                              disabled: 
                        _ctx.props.orderProgress >= _ctx.OrderRequestProgress.Shipped
                      
                            }, null, 8, ["modelValue", "placeholder", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("orderRequest.confirmationDate")), 1),
                        _createVNode(_component_el_form_item, { prop: "confirmation_date" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              class: "w-100",
                              modelValue: _ctx.formData.confirmation_date,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.confirmation_date) = $event)),
                              type: "date",
                              placeholder: _ctx.t('common.pickDate'),
                              onChange: _cache[2] || (_cache[2] = ($event: any) => (
                        _ctx.commonChangeDefaultDate(
                          $event,
                          _ctx.formData,
                          'confirmation_date'
                        )
                      )),
                              disabled: 
                        _ctx.props.orderProgress >= _ctx.OrderRequestProgress.Confirmed
                      ,
                              teleported: false
                            }, null, 8, ["modelValue", "placeholder", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("orderRequest.merchantInvoiceNo")), 1),
                        _createVNode(_component_el_form_item, { prop: "merchant_invoice_number" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.merchant_invoice_number,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.merchant_invoice_number) = $event)),
                              type: "text",
                              placeholder: _ctx.t('common.plsEnter'),
                              clearable: "",
                              disabled: 
                        _ctx.props.orderProgress >= _ctx.OrderRequestProgress.Shipped
                      
                            }, null, 8, ["modelValue", "placeholder", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("orderRequest.shippingDate")), 1),
                        _createVNode(_component_el_form_item, { prop: "shipping_date" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              class: "w-100",
                              modelValue: _ctx.formData.shipping_date,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.shipping_date) = $event)),
                              type: "date",
                              placeholder: _ctx.t('common.pickDate'),
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (
                        _ctx.commonChangeDefaultDate(
                          $event,
                          _ctx.formData,
                          'shipping_date'
                        )
                      )),
                              disabled: 
                        _ctx.props.orderProgress >= _ctx.OrderRequestProgress.Shipped
                      ,
                              teleported: false
                            }, null, 8, ["modelValue", "placeholder", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("shipments.serviceProvider")), 1),
                        _createVNode(_component_el_form_item, { prop: "service_provider" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              modelValue: _ctx.formData.service_provider,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.service_provider) = $event)),
                              clearable: "",
                              placeholder: _ctx.t('common.plsSelect'),
                              disabled: 
                        _ctx.props.orderProgress >= _ctx.OrderRequestProgress.Shipped
                      
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.serviceProvider, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("shipments.trackingNo")), 1),
                        _createVNode(_component_el_form_item, { prop: "tracking_no" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.tracking_no,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.tracking_no) = $event)),
                              type: "text",
                              placeholder: _ctx.t('common.plsEnter'),
                              clearable: "",
                              disabled: 
                        _ctx.props.orderProgress >= _ctx.OrderRequestProgress.Shipped
                      
                            }, null, 8, ["modelValue", "placeholder", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("orderRequest.pcsConfirmed")), 1),
                        _createVNode(_component_el_form_item, { prop: "shipping_qty" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_component_el_input_number, {
                                class: "text-start w-100",
                                modelValue: _ctx.formData.shipping_qty,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.shipping_qty) = $event)),
                                precision: 0,
                                step: 1,
                                min: 1,
                                max: _ctx.subQtyMax,
                                controls: false,
                                disabled: 
                          _ctx.props.orderProgress >= _ctx.OrderRequestProgress.Confirmed
                        
                              }, null, 8, ["modelValue", "max", "disabled"])
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-light me-3",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_27, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
                  ]),
                  _createElementVNode("button", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                    ]),
                    _createElementVNode("span", _hoisted_31, [
                      _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                      _hoisted_32
                    ])
                  ], 512)
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}